<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div>
  <h1 mat-dialog-title>Add New Planning Market</h1>
  <mat-dialog-content>
    <div class="d-flex flex-column gap-8">
      <mat-form-field>
        <mat-label>Planning Market:</mat-label>
        <input matInput [(ngModel)]="planningMarketName">
      </mat-form-field>
    </div>
    <div class="d-flex flex-column gap-8">
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Select Subregion</mat-label>
        <mat-select [(ngModel)]="selectedSubregion" (ngModelChange)="getMarketAreas()">
          <mat-option *ngFor="let subregion of subregions"
                      [value]="subregion">{{ subregion.subregionValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Select Market Area</mat-label>
        <mat-select [(ngModel)]="selectedMarketArea">
          <mat-option *ngFor="let marketArea of marketAreas"
                      [value]="marketArea">{{ marketArea }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="pt-3 d-flex gap-8">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary"
              [disabled]="!selectedSubregion || !planningMarketName || !selectedMarketArea"
              (click)="addPlanningMarket()">
        Create
      </button>
    </div>
  </mat-dialog-content>
</div>
